/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface TicketTimeLimitOverrideListQuery
 */
export interface TicketTimeLimitOverrideListQuery {
    /**
     * 
     * @type {boolean}
     * @memberof TicketTimeLimitOverrideListQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof TicketTimeLimitOverrideListQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {string}
     * @memberof TicketTimeLimitOverrideListQuery
     */
    supplier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TicketTimeLimitOverrideListQuery
     */
    carrier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TicketTimeLimitOverrideListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TicketTimeLimitOverrideListQuery
     */
    limit?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TicketTimeLimitOverrideListQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TicketTimeLimitOverrideListQuery
     */
    relevance?: number | null;
}

export function TicketTimeLimitOverrideListQueryFromJSON(json: any): TicketTimeLimitOverrideListQuery {
    return TicketTimeLimitOverrideListQueryFromJSONTyped(json, false);
}

export function TicketTimeLimitOverrideListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketTimeLimitOverrideListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'supplier': !exists(json, 'supplier') ? undefined : json['supplier'],
        'carrier': !exists(json, 'carrier') ? undefined : json['carrier'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
    };
}

export function TicketTimeLimitOverrideListQueryToJSON(value?: TicketTimeLimitOverrideListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showDisabled': value.showDisabled,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'supplier': value.supplier,
        'carrier': value.carrier,
        'offset': value.offset,
        'limit': value.limit,
        'showDeleted': value.showDeleted,
        'relevance': value.relevance,
    };
}


